var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('login-dialog'),_c('nav-header'),_c('router-view'),_c('editor'),(_vm.needFooter)?_c('system-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }